import React from 'react';
import { Link } from 'gatsby';
import { Text } from '@chakra-ui/react';

const BrandOutput = ({ brand }) => (
  <Text
    color={process.env.GATSBY_STORE === 'MPS' ? 'var(--greyscale-dark-3x)' : '#4B5661'}
    as={Link}
    to={brand.node.custom_url?.url}
  >
    {brand.node.name}
  </Text>
);

const Brand = ({ brandData }) => {
  return brandData ? <BrandOutput brand={brandData} /> : null
};

export default Brand;
